import { render } from "./PageUnderConstruction.vue?vue&type=template&id=65cea4f1&scoped=true"
import script from "./PageUnderConstruction.vue?vue&type=script&lang=js"
export * from "./PageUnderConstruction.vue?vue&type=script&lang=js"

import "./PageUnderConstruction.vue?vue&type=style&index=0&id=65cea4f1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65cea4f1"]])

export default __exports__